import { defineComponent as _defineComponent } from 'vue'
import {
  computed, nextTick, ref, watch
} from 'vue';
import {
  useEventListener, useResizeObserver, useWindowSize
} from '@vueuse/core';
import useResponsiveness from '@/mixins/useResponsiveness';
import X from '@/components/svg-components/X.vue';
import BCXQuickLayer from './BCXQuickLayer.vue';
import BCXMarkdown from './BCXMarkdown.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXMarkdownPopup',
  props: {
    isOpen: { type: Boolean },
    text: null
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as {
  isOpen: boolean;
  text: string;
};





const { isMobileWidth } = useResponsiveness();
const { width: windowWidth, height: windowHeight } = useWindowSize();
const popupContainer = ref<HTMLElement | null>(null);
const actualPopupHeightPx = ref<number | null>(null);

const popupWidthPx = computed(() => {
  if (isMobileWidth.value) return windowWidth.value;
  return Math.min(480, Math.max(320, windowWidth.value - 48));
});

const popupHeightPx = computed(() => {
  if (isMobileWidth.value) return windowHeight.value;
  return Math.max(240, windowHeight.value - 50);
});

const popupHeight = computed<number | 'auto'>(() => (isMobileWidth.value ? popupHeightPx.value : 'auto'));

const popupXPos = computed(() => {
  if (isMobileWidth.value) return 0;
  return Math.max((windowWidth.value - popupWidthPx.value) / 2, 24);
});

const popupYPos = computed(() => {
  if (isMobileWidth.value) return 0;
  const centeredHeight = Math.min(actualPopupHeightPx.value ?? popupHeightPx.value, popupHeightPx.value);
  return Math.max((windowHeight.value - centeredHeight) / 2, 24);
});

useEventListener(document, 'keydown', (event: KeyboardEvent) => {
  if (event.key === 'Escape' && props.isOpen) {
    emit('close');
  }
});

const updatePopupHeight = async () => {
  await nextTick();
  actualPopupHeightPx.value = popupContainer.value?.offsetHeight ?? null;
};

watch(() => props.isOpen, (isOpen) => {
  if (isOpen) updatePopupHeight();
});

watch(() => props.text, () => {
  if (props.isOpen) updatePopupHeight();
});

useResizeObserver(popupContainer, () => {
  if (props.isOpen) updatePopupHeight();
});

return { __sfc: true,props, emit, isMobileWidth, windowWidth, windowHeight, popupContainer, actualPopupHeightPx, popupWidthPx, popupHeightPx, popupHeight, popupXPos, popupYPos, updatePopupHeight, X, BCXQuickLayer, BCXMarkdown }
}

})